function getImperialInchesHeightUntil (height) {
  if (!height || isNaN(height)) {
    return 0
  }
  return Math.round((
    height % 1
  ) * 100) || 0
}

export { getImperialInchesHeightUntil }
